import { CountrySelectorDropdown, PhoneInput } from 'react-international-phone';
import { css, styled } from 'styled-components';

// Define variants using props.theme instead of tailwind config
const variants = {
  default: css`
    border: 1px solid ${props => props.theme.colors.secondary.light.divider} !important;
    &:focus-within {
      border: 2px solid ${props => props.theme.colors.secondary.main.divider} !important;
    }
  `,
  error: css`
    border: 1px solid ${props => props.theme.colors.error.main.border} !important;
  `,
  disabled: css`
    border: 1px solid ${props => props.theme.colors.secondary.light.divider} !important;
    opacity: 0.6 !important;
    cursor: not-allowed !important;
    input {
      cursor: not-allowed !important;
    }
  `,
};

export const StyledPhoneInput = styled(PhoneInput)<{
  variant: 'default' | 'error' | 'disabled';
}>`
  box-sizing: border-box;
  background-color: transparent !important;
  color: ${props => props.theme.colors.secondary.main.text} !important;
  border-radius: 8px !important;
  padding: 7px 11px !important;
  display: flex;
  align-items: center;
  height: 46px !important;
  padding: 0px 8px 0px 4px !important;

  ${({ variant }) => variants[variant]}

  input {
    background-color: transparent !important;
    outline: unset !important;
    border: none !important;
    box-shadow: unset !important;
    color: ${props => props.theme.colors.secondary.main.text} !important;
    width: 100% !important;
    height: unset !important;
    font-size: 1rem !important;
    padding-left: 76px !important;
  }
  > div {
    display: flex;
    align-items: center;

    > button {
      background-color: transparent !important;
      border: none !important;
      outline: unset !important;
      box-shadow: unset !important;
      color: ${props => props.theme.colors.neutral.main.text} !important;
      height: unset !important;
      cursor: pointer !important;
    }
  }

  .react-international-phone-country-selector {
    padding-left: 12px !important;
  }

  .react-international-phone-country-selector-button__dropdown-arrow {
    display: none !important;
  }
  .react-international-phone-dial-code-preview {
    border: none !important;
    padding: 0 4px !important;
    font-size: 16px !important;
    font-weight: 400 !important;
  }
`;

export const StyledCountrySelectorDropdown = styled(CountrySelectorDropdown)`
  width: auto !important;
  padding: 0 !important;
  outline: none !important;
  border-radius: 8px !important;
  .react-international-phone-country-selector-dropdown__list-item-country-name {
    font-size: 16px !important;
    font-weight: 400 !important;
  }

  .react-international-phone-country-selector-dropdown__list-item {
    padding: 12px !important;
    color: ${props => props.theme.colors.secondary.main.text} !important;
  }
  .react-international-phone-country-selector-dropdown__list-item--focused {
    background: ${props => props.theme.colors.primary.light.filled} !important;
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }

  .react-international-phone-country-selector-dropdown__list-item--focused:after {
    content: '✓';
    position: absolute;
    right: 10px;
  }
`;
